import ExcelJS from 'exceljs';

export default class ReporteExistenciasExporter {

    // Exportar Reporte de Existencias a Excel.

// Se espera que cada objeto de "data" tenga la siguiente estructura:
// {
//   Nombre: String,
//   UnidadMedida: String,
//   Codigo: String,
//   Familia: String,
//   Categoria: String,
//   Alerta: Number,
//   AlertaMax: Number,
//   ... // columnas dinámicas según los orígenes (ej: "Origen1", "Origen2", etc.)
//   Total: Number
// }

  static async exportReporteExistencias(data, title = "Reporte Existencias") {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Existencias");

    // Determinar columnas dinámicamente a partir del primer registro.
    let columns;
    if (data && data.length > 0) {
      // Se usa Object.keys para obtener las claves del primer objeto
      // y definir el orden de las columnas.
      columns = Object.keys(data[0]).map(key => ({
        header: key,
        key: key
      }));
    } else {
      // Si no hay datos, se definen columnas por defecto.
      columns = [
        { header: 'Nombre', key: 'Nombre' },
        { header: 'UnidadMedida', key: 'UnidadMedida' },
        { header: 'Codigo', key: 'Codigo' },
        { header: 'Familia', key: 'Familia' },
        { header: 'Categoria', key: 'Categoria' },
        { header: 'Alerta', key: 'Alerta' },
        { header: 'AlertaMax', key: 'AlertaMax' },
        { header: 'Total', key: 'Total' },
      ];
    }
    worksheet.columns = columns;

    // Insertar dos filas al inicio:
    // - Fila 1: Título
    // - Fila 2: Fila vacía (para separar)
    worksheet.insertRow(1, [title]);
    worksheet.insertRow(2, []);

    // Fusionar celdas de la fila 1 según la cantidad de columnas
    const lastColLetter = worksheet.getColumn(worksheet.columns.length).letter;
    worksheet.mergeCells(`A1:${lastColLetter}1`);

    // Dar formato al título (fila 1)
    const titleCell = worksheet.getCell('A1');
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
    titleCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFADD8E6' }, // Azul claro
    };

    // La fila de encabezados se desplazó a la fila 3, así que se le aplica formato
    const headerRow = worksheet.getRow(3);
    headerRow.font = { bold: true, size: 12 };
    headerRow.alignment = { horizontal: 'center' };
    headerRow.eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD3D3D3' } // Gris claro para encabezados
      };
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Añadir filas de datos (a partir de la fila 4)
    data.forEach(item => {
        const row = worksheet.addRow(item);
        // Alinear cada celda de la fila a la izquierda.
        row.eachCell({ includeEmpty: true }, cell => {
          cell.alignment = { horizontal: 'left' };
        });
      });

    // Autoajuste del ancho de columnas según el contenido
    worksheet.columns.forEach(column => {
      let maxLength = column.header.toString().length;
      column.eachCell({ includeEmpty: true }, cell => {
        const cellValue = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength + 5;
    });

    return workbook.xlsx.writeBuffer();
  }
}
